import { WebsiteFavicon } from "#components/ui/WebsiteFavicon.tsx";
import { SourcePreview } from "#features/conversations/components/conversation-source/source-preview/SourcePreview.tsx";
import type { SourcePreviewProps } from "#features/conversations/components/conversation-source/source-preview/SourcePreviewProps.ts";
import { useConversationSource } from "#features/conversations/hooks/useConversationSource.ts";
import type { WebPageCustomProperties } from "#types/types.ts";

export const WebPagePreview = ({ source }: SourcePreviewProps) => {
    const { description, title, author, date } = useConversationSource(source);
    const { url, rootUrlFriendlyName } = source.customProperties as WebPageCustomProperties;

    return (
        <SourcePreview
            source={source}
            title={title}
            author={author}
            date={date}
            description={description}
            appName={rootUrlFriendlyName}
            tile={<WebsiteFavicon url={url} />}
        />
    );
};
